export enum Keys {
  ESC = 27
}
